import { render, staticRenderFns } from "./TranslateImageButton.vue?vue&type=template&id=07eed25f"
import script from "./TranslateImageButton.vue?vue&type=script&lang=js"
export * from "./TranslateImageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07eed25f')) {
      api.createRecord('07eed25f', component.options)
    } else {
      api.reload('07eed25f', component.options)
    }
    module.hot.accept("./TranslateImageButton.vue?vue&type=template&id=07eed25f", function () {
      api.rerender('07eed25f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/TranslateImageButton.vue"
export default component.exports